export class ManualCodeDto {
    code: string;

    constructor() {
        this.code = '';
    }
}
